/* eslint-disable class-methods-use-this */
define(
  'marqueeGalleryHandler',[
    'builderShowcaseObserver',
    'fastdom'
  ],
  (
    builderShowcaseObserver,
    fastdom
  ) => {
    'use strict';

    class GalleryHandler {
      constructor(configObject) {
        this.config = configObject;
        this.init();
      }

      /**
     * Initialize the marquee gallery
     * Gets the collection data from the script, and set it in the State.
     */
      init() {
        const data = document.querySelector('[data-marquee-gallery-collections]');

        if (!data) {
          return;
        }

        const galleryCollections = { };
        const collections = JSON.parse(data.innerHTML);
        for (let i = 0; i < collections.length; i += 1) {
          const collectionName = `${collections[i].Category.toLowerCase()}Collection`;
          galleryCollections[collectionName] = collections[i];
        }

        builderShowcaseObserver.setData({ galleryCollections });
        builderShowcaseObserver.commit();
      }

      /**
       * Replaces marquee main picture img with the active picture image.
       * @param {object} picture Picture Html Object
       */
      displayNewImage(picture) {
        fastdom.mutate(() => {
          this.config.mainViewer.innerHTML = '';
          this.config.mainViewer.appendChild(picture);
        });
      }

      /**
       * Method subscribed to OnImageSelected event,
       * this will receive the active image object as input to build and replace the marquee main image.
       * @param {object} data active image object
       */
      update(data) {
        const activeImage = data;

        if (!activeImage || (activeImage.MainImageSources.length === 0 && !activeImage.isLiteGalleryModal)) {
          return;
        }

        const picture = document.createElement('picture');
        const sources = activeImage.MainImageSources || [];

        sources.forEach((sourceItem) => {
          const source = document.createElement('source');
          source.srcset = sourceItem.Srcset;
          source.type = sourceItem.ImageType;
          picture.appendChild(source);
        });
        const img = document.createElement('img');
        img.src = activeImage.MainPictureImage.ImageUrl;
        img.alt = activeImage.Caption;
        img.onerror = function (event) {
          const target = event.target;
          const parent = target.parentElement;
          const imgSources = parent.querySelectorAll('source');

          imgSources.forEach((source) => {
            parent.removeChild(source);
          });

          target.onerror = null;
          img.src = activeImage.MainPictureImage.NoPhoto;
        };

        picture.appendChild(img);
        this.displayNewImage(picture);
      }
    }

    return GalleryHandler;
  }
);

